// Photo strip on Chapter sections (snippets/history-chapter-block.liquid): arrows and a "3 / 20" counter.
// Opening a photo full size is handled by article-story.js.
if (!customElements.get('klpd-photo-strip')) {
  customElements.define(
    'klpd-photo-strip',
    class KlpdPhotoStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.chapter-strip__track');
        this.items = [...this.track.children];
        this.current = this.querySelector('[data-strip-current]');
        this.querySelector('[data-strip-prev]').addEventListener('click', () => this.step(-1));
        this.querySelector('[data-strip-next]').addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
      }

      // Index of the first photo whose left edge is in view
      index() {
        const left = this.track.scrollLeft;
        const i = this.items.findIndex((item) => item.offsetLeft - this.track.offsetLeft >= left - 4);
        return i === -1 ? this.items.length - 1 : i;
      }

      step(direction) {
        const target = this.items[Math.max(0, Math.min(this.items.length - 1, this.index() + direction))];
        this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      update() {
        this.current.textContent = this.index() + 1;
      }
    }
  );
}
